(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-configurator-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var groups = document.querySelectorAll('.atelier-cfgband__visual-slides');
    groups.forEach(function (group) {
      var slides = group.querySelectorAll('.atelier-cfgband__visual-img');
      if (slides.length < 2) return;
      var index = 0;
      setInterval(function () {
        slides[index].classList.remove('atelier-cfgband__visual-img--active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('atelier-cfgband__visual-img--active');
      }, 4000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-atelier-hcar]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var slides = root.querySelectorAll('[data-atelier-hcar-slide]');
      if (slides.length < 2) {
        if (slides.length === 1) slides[0].classList.add('is-active');
        return;
      }

      var track = root.querySelector('[data-atelier-hcar-track]');
      var prevBtn = root.querySelector('[data-atelier-hcar-prev]');
      var nextBtn = root.querySelector('[data-atelier-hcar-next]');
      var dots = root.querySelectorAll('[data-atelier-hcar-dot]');
      var current = root.querySelector('[data-atelier-hcar-current]');
      var progress = root.querySelector('[data-atelier-hcar-progress]');
      var live = root.querySelector('[data-atelier-hcar-live]');
      var toggle = root.querySelector('[data-atelier-hcar-toggle]');

      var total = slides.length;
      var index = 0;
      var autoplayWanted = root.dataset.autoplay === 'true';
      var intervalMs = parseInt(root.dataset.interval, 10) || 6000;
      var timer = null;
      var paused = false;
      var isFade = root.classList.contains('atelier-hcar--fade');

      var reduceMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) {
        autoplayWanted = false;
      }

      function setProgress(reset) {
        if (!progress) return;
        if (reset) {
          progress.style.transition = 'none';
          progress.style.width = '0%';
          progress.offsetWidth;
        }
        if (!paused && autoplayWanted) {
          progress.style.transition = 'width ' + intervalMs + 'ms linear';
          progress.style.width = '100%';
        } else {
          progress.style.transition = 'none';
        }
      }

      function update(newIndex, focusContent) {
        var prev = index;
        index = ((newIndex % total) + total) % total;

        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          if (active) {
            slide.removeAttribute('aria-hidden');
            slide.removeAttribute('inert');
          } else {
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('inert', '');
          }
        });

        if (!isFade && track) {
          track.style.transform = 'translate3d(-' + index * 100 + '%, 0, 0)';
        }

        dots.forEach(function (dot, i) {
          var active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        if (current) current.textContent = String(index + 1);
        if (live && prev !== index) {
          live.textContent = 'Diapositive ' + (index + 1) + ' sur ' + total;
        }

        setProgress(true);

        if (focusContent) {
          var content = slides[index].querySelector('.atelier-hcar__content');
          if (content) {
            content.setAttribute('tabindex', '-1');
            content.focus({ preventScroll: true });
            content.removeAttribute('tabindex');
          }
        }
      }

      function next() {
        update(index + 1);
      }

      function prev() {
        update(index - 1);
      }

      function start() {
        stop();
        if (!autoplayWanted || paused) return;
        setProgress(true);
        timer = window.setInterval(next, intervalMs);
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function pause() {
        paused = true;
        stop();
        if (progress) {
          var computed = window.getComputedStyle(progress).width;
          progress.style.transition = 'none';
          progress.style.width = computed;
        }
        if (toggle) {
          toggle.setAttribute('aria-pressed', 'false');
          toggle.setAttribute('aria-label', 'Reprendre le carrousel');
        }
      }

      function resume() {
        paused = false;
        if (toggle) {
          toggle.setAttribute('aria-pressed', 'true');
          toggle.setAttribute('aria-label', 'Mettre le carrousel en pause');
        }
        start();
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resume(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); resume(); });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.dataset.index, 10);
          if (!isNaN(i)) {
            update(i);
            resume();
          }
        });
      });

      if (toggle) {
        toggle.addEventListener('click', function () {
          if (paused) resume(); else pause();
        });
      }

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', function () {
        if (!paused) start();
      });
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', function () {
        if (!paused) start();
      });

      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          next();
          resume();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          prev();
          resume();
        }
      });

      var viewport = root.querySelector('[data-atelier-hcar-viewport]');
      if (viewport && 'ontouchstart' in window) {
        var sx = 0;
        var sy = 0;
        var moved = false;
        viewport.addEventListener(
          'touchstart',
          function (e) {
            var t = e.touches[0];
            sx = t.clientX;
            sy = t.clientY;
            moved = false;
            stop();
          },
          { passive: true }
        );
        viewport.addEventListener(
          'touchmove',
          function (e) {
            var t = e.touches[0];
            if (Math.abs(t.clientX - sx) > 10) moved = true;
          },
          { passive: true }
        );
        viewport.addEventListener(
          'touchend',
          function (e) {
            var t = e.changedTouches[0];
            var dx = t.clientX - sx;
            var dy = t.clientY - sy;
            if (moved && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
              if (dx < 0) next(); else prev();
              resume();
            } else {
              if (!paused) start();
            }
          },
          { passive: true }
        );
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else if (!paused) start();
      });

      update(0);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-key-figures"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.atelier-keyfig');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var nums = section.querySelectorAll('[data-atelier-keyfig-num]');
      if (!nums.length) return;
      var done = false;

      var reduceMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function animate() {
        if (done) return;
        var rect = section.getBoundingClientRect();
        if (rect.top > window.innerHeight * 0.85) return;
        done = true;

        nums.forEach(function (el) {
          var raw = el.getAttribute('data-target') || '0';
          var suffix = el.getAttribute('data-suffix') || '';
          var target = parseFloat(raw.replace(',', '.')) || 0;
          var decimals = raw.indexOf('.') > -1 || raw.indexOf(',') > -1 ? 1 : 0;

          if (reduceMotion) {
            el.textContent = (decimals ? target.toFixed(decimals) : Math.round(target)) + suffix;
            return;
          }

          var startTime = null;
          function step(ts) {
            if (!startTime) startTime = ts;
            var progress = Math.min((ts - startTime) / 1200, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var value = target * eased;
            el.textContent = (decimals ? value.toFixed(decimals) : Math.round(value)) + suffix;
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      }

      window.addEventListener('scroll', animate, { passive: true });
      animate();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-password"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-atelier-pw-countdown]');
    if (!root) return;
    var endStr = root.getAttribute('data-end');
    if (!endStr) return;
    var end = new Date(endStr);
    if (isNaN(end.getTime())) {
      root.setAttribute('hidden', '');
      return;
    }

    var active = root.querySelector('[data-atelier-pw-countdown-active]');
    var dEl = root.querySelector('[data-d]');
    var hEl = root.querySelector('[data-h]');
    var mEl = root.querySelector('[data-m]');
    var sEl = root.querySelector('[data-s]');
    var ended = root.querySelector('[data-atelier-pw-ended]');

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var now = new Date();
      var ms = end - now;
      if (ms <= 0) {
        if (active) active.hidden = true;
        if (ended) ended.hidden = false;
        return;
      }
      if (active) active.hidden = false;
      if (ended) ended.hidden = true;
      var sec = Math.floor(ms / 1000);
      var days = Math.floor(sec / 86400);
      sec -= days * 86400;
      var hrs = Math.floor(sec / 3600);
      sec -= hrs * 3600;
      var min = Math.floor(sec / 60);
      sec -= min * 60;
      if (dEl) dEl.textContent = String(days);
      if (hEl) hEl.textContent = pad(hrs);
      if (mEl) mEl.textContent = pad(min);
      if (sEl) sEl.textContent = pad(sec);
    }

    tick();
    window.setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
